export function activeCompanyID() {
  return (
    localStorageValue("activeCompanyId") ||
    localStorageValue("datox.agent.companyId") ||
    import.meta.env.VITE_DATOX_AGENT_COMPANY_ID ||
    "00000000-0000-0000-0000-000000000101"
  )
}

export function setActiveCompanyID(companyID: string) {
  try {
    if (activeCompanyID() !== companyID) localStorage.removeItem("datox.agent.selectedProjectId")
    localStorage.setItem("activeCompanyId", companyID)
    localStorage.setItem("datox.agent.companyId", companyID)
  } catch {
    return
  }
}

// Settings > Admin's switch, and the V2 rail's company menu: an active company only, then the app afresh at /.
export function switchCompany(company: { id: string; status: string }) {
  if (company.status !== "active") return
  setActiveCompanyID(company.id)
  window.location.assign("/")
}

export function localDevHeaders() {
  return {
    "X-User-Id": localStorageValue("datox.agent.userId") || import.meta.env.VITE_DATOX_AGENT_USER_ID || "00000000-0000-0000-0000-000000000001",
    "X-User-Email": localStorageValue("datox.agent.userEmail") || import.meta.env.VITE_DATOX_AGENT_USER_EMAIL || "user@datox.ai",
    "X-Active-Company-Id": activeCompanyID(),
  }
}

function localStorageValue(key: string) {
  try {
    return localStorage.getItem(key) || ""
  } catch {
    return ""
  }
}
